import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import localStorage from 'local-storage';
import {Container, Row, Col} from 'react-bootstrap';
import Popup from 'reactjs-popup';

import '../css/AdviserDashboard1.css'
import '../css/StaticHeader.css'
//import Logout from './Logout';
import { apiHost } from '../Redux/action';

class StaticHeader extends Component{
    constructor(props){
        super(props)
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            openMenu: false,
        }
    }
    
    componentDidMount(){
       this._onPageLoad()
    }

    componentDidUpdate(prevProps, prevState) {
        // if(prevProps.history.location.pathname !== this.props.history.location.pathname)
            this._onPageLoad();
    }

    _onPageLoad() {
        if(String(this.props.history.location.pathname).includes("login")){
            // this.props.history.push("/adv/login");
            document.getElementById("myPortfolio").style.color = "#51820F";
            document.getElementById("members").style.color = "#333333";
            document.getElementById("forms").style.color = "#333333";
        }
        
        if(String(this.props.history.location.pathname).includes("totalMembers")){
            // this.props.history.push("/adv/totalMembers");
            document.getElementById("members").style.color = "#51820F";
            document.getElementById("myPortfolio").style.color = "#333333";
            document.getElementById("forms").style.color = "#333333";
        }
    }

    handleClick(e){
        localStorage.set("selectedMenu", e.target.id);
        e.preventDefault();
        // e.target.style.color = "#81B037";
        e.target.style.color = "#51820F";
        this.setState({openMenu: false})
        if( e.target.id === "myPortfolio"){
            document.getElementById("members").style.color = "#333333";
            document.getElementById("forms").style.color = "#333333";
            document.getElementById("joinUp").style.color = "#333333";
            document.getElementById("contactUs").style.color = "#333333";


            this.props.history.push("/adv/login");
        }
        if( e.target.id === "members"){
            document.getElementById("myPortfolio").style.color = "#333333";
            document.getElementById("forms").style.color = "#333333";
            document.getElementById("joinUp").style.color = "#333333";
            document.getElementById("contactUs").style.color = "#333333";

            this.props.history.push("/adv/totalMembers");
        }
        if(e.target.id === "forms"){
            document.getElementById("myPortfolio").style.color = "#333333";
            document.getElementById("members").style.color = "#333333";
            document.getElementById("joinUp").style.color = "#333333";
            document.getElementById("contactUs").style.color = "#333333";

            window.open("https://www.superlife.co.nz/resources/forms", "_blank")
        }
        if(e.target.id === "joinUp"){
            document.getElementById("myPortfolio").style.color = "#333333";
            document.getElementById("members").style.color = "#333333";
            document.getElementById("forms").style.color = "#333333";
            document.getElementById("contactUs").style.color = "#333333";

            window.open(`${apiHost}/slc/joinup.do?faid=${!this.props.advisers ? " " : this.props.groupLogin ? 
            Object.keys(this.props.advisers).map(key => this.props.advisers[key])[0].groupName :
            Object.keys(this.props.advisers).map(key => this.props.advisers[key]).map(adviser => adviser.adviserName)}`, "_blank")
        }
        if(e.target.id === "contactUs") {
            document.getElementById("myPortfolio").style.color = "#333333";
            document.getElementById("members").style.color = "#333333";
            document.getElementById("forms").style.color = "#333333";
            document.getElementById("joinUp").style.color = "#333333";

            window.open("https://www.superlife.co.nz/about/contact-us", "_blank")
        }
    }

    render(){
        const {t} = this.props
        const advisersData = this.props.advisers || {}
        return(
            <div>
                {/* <div style={{background: "green"}}>
                    <header  className="staticHeader">
                        <Container>
                            <Row>
                                <Col><Logout keycloak={this.props.keycloak}/></Col>
                                <Col><text className="loggedIn">{t('logged')+" "+t('in'+" "+t('as'))}: {
                                    !this.props.advisers ? " " : this.props.groupLogin ? 
                                    Object.keys(this.props.advisers).map(key => this.props.advisers[key])[0].groupName :
                                    Object.keys(this.props.advisers).map(key => this.props.advisers[key]).map(adviser => adviser.adviserName)
                                    }</text></Col>
                                <Col style={{display: "block"}}>{!this.props.member ? " " : <text className="loggedIn">{t('member')}: {this.props.member.displayName}</text>}</Col>
                                
                                <Col><Link className="staticHeader link link-staticHeader" 
                                    style={{paddingTop:"12px", 
                                    paddingLeft: "30px", paddingRight:"30px", 
                                    float: "right"}}
                                    to="https://www.superlife.co.nz/about/contact-us">{t('contact')+" "+t('us')}</Link></Col>
                                <Col><text className="staticHeader" style={{paddingTop:"12px", float: "right"}}>{t('home')}</text></Col>
                            </Row>
                        </Container> */}
                        {/* <Logout keycloak={this.props.keycloak}/>
                        <table style={{float: "right"}}>
                            <tbody>
                                <tr><text className="loggedIn">{t('logged')+" "+t('in'+" "+t('as'))}: {
                                    !this.props.advisers ? " " : this.props.groupLogin ? 
                                    Object.keys(this.props.advisers).map(key => this.props.advisers[key])[0].groupName :
                                    Object.keys(this.props.advisers).map(key => this.props.advisers[key]).map(adviser => adviser.adviserName)
                                    }</text></tr>
                                <tr>
                                    {!this.props.member ? " " : <text className="loggedIn">{t('member')}: {this.props.member.displayName}</text>}
                                </tr>
                            </tbody>
                        </table>
                
                        <text className="staticHeader" style={{paddingTop:"12px", paddingLeft: "30px", paddingRight:"30px", float: "right"}}>{t('contact')+" "+t('us')}</text>
                        <text className="staticHeader" style={{paddingTop:"12px", float: "right"}}>{t('home')}</text> */}
                    {/* </header>
                </div> */}
                <div className="headerMenuDiv">
                    <div className="headerMenu">
                        
                        <Container className="container" fluid>
                            <Row style={{display: "flex", justifyContent: "space-between"}}>
                                {/* For Local */}
                                {/* <Col className="superlife-image">
                                    <Link className="imageLink" to="/adv/login" >
                                        <img id="superlifeImageFull" className="staticHeader" src="/images/superlife-member-of-nzx-group-logo-200-2x.png" alt="superlife.png"></img>
                                        <img id="superlifeImageLogo" className="staticHeader" src="/images/superlife-member-of-nzx-group-logo-62-2x.png" alt="superlife.png"></img>
                                    </Link>
                                </Col> */}
                                {/* For Dev-Server */}
                                <Col>
                                    <Link className="imageLink" to="/adv/login" >
                                        <img id="superlifeImageFull" className="staticHeader" src="/adviser/images/superlife-member-of-nzx-group-logo-200-2x.png" alt="superlife.png"></img>
                                        <img id="superlifeImageLogo" className="staticHeader" src="/adviser/images/superlife-member-of-nzx-group-logo-62-2x.png" alt="superlife.png"></img>
                                    </Link>
                                </Col>

                                <Col id="wideMenu"><Link className="link link-staticHeader" id="myPortfolio" to="/adv/login"  onClick={e => this.handleClick(e)}>{t('StaticHeader:home')}</Link></Col>
                                <Col id="wideMenu"><Link className="link link-staticHeader" id="members" to="/adv/totalMembers" onClick={e => this.handleClick(e)}>{t('StaticHeader:members')}</Link></Col>
                                <Col id="wideMenu"><Link className="link link-staticHeader" target="_blank" id="forms" 
                                    to="https://www.superlife.co.nz/resources/forms" 
                                    onClick={e => this.handleClick(e)}
                                >{t('StaticHeader:forms')}</Link></Col>
                                {/* Kiwisaver Application button */}
                                <Col lg={3}  id="wideMenu">
                                    <Link className="link link-staticHeader" target="_blank" id="joinUp" 
                                    to={`${apiHost}/slc/joinup.do?faid=${!this.props.advisers ? " " : this.props.groupLogin ? 
                                    Object.keys(this.props.advisers).map(key => this.props.advisers[key])[0].groupName :
                                    Object.keys(this.props.advisers).map(key => this.props.advisers[key]).map(adviser => adviser.adviserName)}`}
                                    onClick={e => this.handleClick(e)}
                                >{t('StaticHeader:kiwiSaverApplication')}</Link></Col>
                                {/* Contact us button */}
                                <Col id="wideMenu"><Link className="link link-staticHeader" target="_blank" id="contactUs" 
                                    to="https://www.superlife.co.nz/about/contact-us" 
                                    onClick={e => this.handleClick(e)}>{t('StaticHeader:contactUs')}</Link></Col>
                                {/* Logout button */}
                                <Col id="wideMenu"><Link className="link link-staticHeader" id="logOut" 
                                        to="/adv/login" onClick={e => {
                                        this.props.history.push("/adv/login");
                                        this.props.keycloak.logout()}}>{t('StaticHeader:logout')}</Link></Col>


                                {/* MenuPopup is displayed when screen size is small and cannot fit the main menu */}
                                <Popup className="menuPopup"
                                    trigger={<Col className="menu-position"><button className="staticHeaderMenu" onClick={e => this.setState({openMenu: true})}>
                                    {/* For Local */}
                                    {/* <img className="staticHeaderMenu" src="/images/menu.png" alt="menu.png"></img> */}
                                    {/* For Dev-Server */}
                                    <img className="staticHeaderMenu" src="/adviser/images/menu.png" alt="menu.png"></img>
                                    </button> </Col>} 
                                    open={this.state.openMenu}
                                    position="bottom center">
                                    <div>
                                        <div className="menuDiv">
                                            <Link style={{display: "block"}} className="link menuPopupLinks" id="myPortfolio" to="/adv/login"  onClick={e => this.handleClick(e)}>{t('StaticHeader:home')}</Link>                                            
                                            {
                                                !String(this.props.history.location.pathname).includes("memberSite") 
                                                    // && this.props.member && this.props.member.usrMemberSetId
                                                ? <Link style={{display: "block"}} className="link menuPopupLinks" id="members" to="/adv/totalMembers"  onClick={e => this.handleClick(e)}>{t('StaticHeader:members')}</Link> 
                                                : <div>
                                                    <Link style={{display: "block"}} className="link menuPopupLinks" id="members" to="/adv/totalMembers"  onClick={e => this.handleClick(e)}>{t('StaticHeader:members')}</Link>
                                                    <div style={{paddingLeft:"10px"}}>
                                                        <Link style={{display: "block"}} className="link menuPopupLinks" 
                                                            to={!this.props.member
                                                                ?"adv/totalMembers"
                                                                : `/adv/memberSite/${this.props.member.usrMemberSetId}/personalDetails/summary`}
                                                            onClick={e => this.setState({openMenu: false})}>{t('memberSite:personalDetails')}</Link>
                                                        <Link style={{display: "block"}} className="link menuPopupLinks" 
                                                            to={!this.props.member
                                                                ?"adv/totalMembers"
                                                                : `/adv/memberSite/${this.props.member.usrMemberSetId}/contributionDetails/summary`}
                                                            onClick={e => this.setState({openMenu: false})}>{t('memberSite:contributionDetails')}</Link>
                                                        <Link style={{display: "block"}} className="link menuPopupLinks" 
                                                            to={!this.props.member
                                                                ?"adv/totalMembers"
                                                                : `/adv/memberSite/${this.props.member.usrMemberSetId}/balanceByAccount/accounts`}
                                                            onClick={e => this.setState({openMenu: false})}>{t('memberSite:balanceByAccount')}</Link>
                                                        <Link style={{display: "block"}} className="link menuPopupLinks" 
                                                            to={!this.props.member
                                                                ?"adv/totalMembers"
                                                                :`/adv/memberSite/${this.props.member.usrMemberSetId}/transactionHistory/summary`}
                                                            onClick={e => this.setState({openMenu: false})}>{t('memberSite:transactionHistory')}</Link>
                                                        <Link style={{display: "block"}} className="link menuPopupLinks" 
                                                            to={!this.props.member
                                                                ?"adv/totalMembers"
                                                                :`/adv/memberSite/${this.props.member.usrMemberSetId}/futureStrategy/investments`}
                                                            onClick={e => this.setState({openMenu: false})}>{t('memberSite:futureStrategy')}</Link>
                                                        <Link style={{display: "block"}} className="link menuPopupLinks" 
                                                            to={!this.props.member
                                                                ?"adv/totalMembers"
                                                                : `/adv/memberSite/${this.props.member.usrMemberSetId}/documents/all`}
                                                            onClick={e => this.setState({openMenu: false})}>{t('memberSite:documents')}</Link>
                                                    </div>
                                                    </div>

                                            }
                                            <Link style={{display: "block"}} className="link menuPopupLinks" target="_blank" id="forms" 
                                                to="https://www.superlife.co.nz/resources/forms" 
                                                onClick={e => this.handleClick(e)}>{t('StaticHeader:forms')}</Link>
                                            <Link style={{display: "block"}} className="link menuPopupLinks" target="_blank" id="joinUp" 
                                                to={`${apiHost}/slc/joinup.do?faid=${!this.props.advisers ? " " : this.props.groupLogin ? 
                                                Object.keys(this.props.advisers).map(key => this.props.advisers[key])[0].groupName :
                                                Object.keys(this.props.advisers).map(key => this.props.advisers[key]).map(adviser => adviser.adviserName)}`}
                                                onClick={e => this.handleClick(e)}>{t('StaticHeader:kiwiSaverApplication')}</Link>
                                            {/* <Logout style={{float: "left !important"}} keycloak={this.props.keycloak}/> */}
                                            <Link style={{display: "block"}} className="link menuPopupLinks" to="/adv/login" onClick={e => {
                                                this.props.history.push("/adv/login");
                                                this.props.keycloak.logout()}}>{t('StaticHeader:logout')}</Link>
                                        </div>
                                    </div>
                                </Popup>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>)
        }
    }

    export default withTranslation()(StaticHeader);